import { create } from 'zustand';
import { v4 as uuid } from 'uuid';
import { useEffect } from 'react';

interface OverlayPanelModalStackStoreState {
  stack: string[];
  pushItem: (item: string) => void;
  removeItem: (item: string) => void;
  clear: () => void;
}

export const useOverlayPanelModelStackStore = create<OverlayPanelModalStackStoreState>((set) => ({
  stack: [],
  pushItem: (item: string) => set((state) => ({ stack: [item, ...state.stack] })),
  removeItem: (item: string) => set((state) => ({ stack: state.stack.filter((i) => i !== item) })),
  clear: () => set({ stack: [] }),
}));

export function useOverlayPanelModelStackGuardForModal(open: boolean) {
  const { removeItem, pushItem } = useOverlayPanelModelStackStore();

  useEffect(() => {
    if (open) {
      const id = uuid();
      pushItem(id);
      return () => removeItem(id);
    }
  }, [open, pushItem, removeItem]);
}
